import type { DirectoryScope } from "./new-chat-page"

interface DirectoryScopeTabsProps {
  value: DirectoryScope
  onChange: (scope: DirectoryScope) => void
}

/**
 * Scope tab bar shared by every directory picker (New Chat, and later New
 * Group / Add Members / Calls). Global first: it's the default reach now, so
 * it reads left-to-right as "widest to narrowest" instead of requiring a tap
 * to get off sub-Organization.
 */
const SCOPE_TABS: { value: DirectoryScope; label: string }[] = [
  { value: 'global', label: 'Global' },
  { value: 'scopeId', label: 'Organization' },
  { value: 'subId', label: 'sub-Organization' },
]

export function DirectoryScopeTabs({ value, onChange }: DirectoryScopeTabsProps) {
  return (
    <div className="flex gap-1.5 px-4 py-2.5 border-b border-stroke-100 dark:border-border shrink-0">
      {SCOPE_TABS.map(s => (
        <button
          key={s.value}
          onClick={() => onChange(s.value)}
          /* An unselected pill has to be visible against a WHITE page, and
             nothing in the light palette sits between `card` (1.0) and
             `muted` (0.97): a three-hundredths difference, so a muted fill
             has no perceivable edge and the control reads as plain text.
             `border-muted-foreground` (0.556 light, #a3a3a3 dark) is the
             only mid-tone available and gives the chip a real outline in
             both themes. Text is `foreground`, not `muted-foreground`, so
             the label itself is never the faint part either. */
          className={`px-3 py-1 rounded-full text-xs font-semibold transition-colors border ${
            value === s.value
              ? 'bg-primary text-white border-primary'
              : 'bg-muted text-foreground border-muted-foreground hover:bg-accent'
          }`}
        >
          {s.label}
        </button>
      ))}
    </div>
  )
}
